<template>
  <generic-modal :title="$t('service menu')" ref="generic_modal">
    <section class="section container">
      <div class="grid is-col-min-6">
        <div class="cell" @click="reception">
          <div class="card">
            <div class="card-image">
              <figure class="image is-64x64 m-auto py-4">
                <img
                  src="https://cdn-icons-png.freepik.com/512/9835/9835859.png"
                />
              </figure>
            </div>
            <div class="card-content px-0">
              <div class="media">
                <div class="media-content">
                  <p class="title is-5 has-text-centered">
                    {{ $t("reception") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cell" @click="replacements">
          <div class="card">
            <div class="card-image">
              <figure class="image is-64x64 m-auto py-4">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/13505/13505609.png"
                />
              </figure>
            </div>
            <div class="card-content px-0">
              <div class="media">
                <div class="media-content">
                  <p class="title is-5 has-text-centered">
                    {{ $t("replacement parts") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
    <reception-modal ref="reception_modal"></reception-modal>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  get,
  post,
  error_alert,
  api_host,
  input_alert,
  generate_error_message_text,
  get_currency_settings,
  confirm_deletion_dialog,
  format_date,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import ReceptionModal from "../service_datatable/service_modal/Index.vue";

export default {
  name: "CalendarServiceModal",
  components: {
    GenericModal,
    ReceptionModal,
  },
  data() {
    let v = this;
    return {
      service_uuid: "",
    };
  },
  computed: {},
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(service_uuid) {
      let v = this;
      v.set_initial_state();
      v.service_uuid = service_uuid;
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.service_uuid = "";
    },
    reception() {
      let v = this;
      v.$refs.reception_modal.edit_modal(v.service_uuid);
      // v.close_modal();
    },
    replacements() {
      let v = this;
      // v.$refs.replacements_modal.edit_modal(v.service_uuid);
      // v.close_modal();
    },
  },
  created() {},
  watch: {},
};
</script>
<style></style>
